import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FilesComponent } from './files/files.component';
import { KeepAliveFilesComponent } from './keep-alive-files/keep-alive-files.component';
import { SupplierControlComponent } from './supplier-control/supplier-control.component';

const routes: Routes = [
  {
    path: 'files',
    component: FilesComponent,
  },
  {
    path: 'supplierControl',
    component: SupplierControlComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'dashboardIframe',
    component: DashboardComponent,
  },
  {
    path: 'keepAliveFiles',
    component: KeepAliveFilesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtherRoutingModule {}
